module.exports = __webpack_public_path__ + "img/safari_120.a84ee554.png";